module.exports = __webpack_public_path__ + "static/media/moneybudget.87f73d47.png";